import React from "react";
import TagInfo from "../util/tag";

export default function Sku(props: { className?: string, children: string | TagInfo, full?: boolean, tag?: React.ComponentProps<any> }) {
    let { 0: tag, 1: setTag } = React.useState<TagInfo | null>(null);
    let Tag = React.useMemo(() => props.tag ?? 'span', [props.tag]);
    let keys = React.useMemo(() => {
        let result = [];
        for (let key of (tag?.rule?.config ?? TagInfo.parseRules).fields) {
            let value = (tag?.parts ?? {})[key];
            if (value) {
                result.push(key);
            }
        }
        return result;
    }, [tag]);
    React.useEffect(() => {
        if (typeof props.children === 'string') {
            TagInfo.fromEpc(props.children, setTag);
        } else {
            setTag(props.children);
        }
    }, [props.children]);
    if (tag && keys.length && props.full) {
        return (
            <Tag className={props.className}>
                {keys.map((key, i) => (
                    <React.Fragment key={'p-' + key}>
                        {i === 0 ? null : (<span>-</span>)}
                        <span style={{ fontWeight: (tag.rule?.config ?? TagInfo.parseRules)?.sku?.includes(key) ? 'bold' : 'normal' }}>{tag.parts[key]}</span>
                    </React.Fragment>
                ))}
            </Tag>
        );
    }
    return (
        <Tag className={props.className} title={tag?.code} style={{ fontWeight: 'bold' }}>{tag?.sku || tag?.code || ''}</Tag>
    );
}
